import { useEffect, useContext, useState } from "react";
import { faUserAltSlash, faUserClock, faUsers, faArrowsRotate, faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { cerrarSession, returnMayus } from "../../utils/funciones";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataContext } from "../../contextData/contextData";
import { PUESTOS } from "../../utils/Constants";
import { modalEjecutar } from "./sweetAlerts";
import { getUno } from "../../api/apis";
import { Link } from "react-router-dom";
import { Icono } from "./Iconos";
import "../../css/sidebar.css";

const returnTo = () => (["7"].includes(localStorage.getItem("id_perfil")) ? "/" : "/firma-contrato");

export const SideBar = ({ ejecutar }) => {
  const idPerfil = localStorage.getItem("id_perfil");
  const { notificaciones } = useContext(DataContext);
  const [version, setVersion] = useState(undefined);
  const [modulo, setModulo] = useState(undefined);

  useEffect(() => {
    async function obtenerVersion() {
      const resp = await getUno("version");
      setVersion(resp.data);
      setModulo(localStorage.getItem("modulo"));
    }
    obtenerVersion();
  }, []);

  return (
    <>
      <div className="offcanvas modalSideBar offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
        <div className="offcanvas-header bgArcoprime">
          <a className="navbar-brand" href="/">
            <div className="logoBlanco"></div>
          </a>
          <button id="sideBarBtn" className="btn btn-primary btnSidebar" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample" style={{ paddingRight: "12px", paddingLeft: "10px" }}>
            <Icono iconName="arrowLeft" />
          </button>
        </div>

        <div className="offcanvas-body">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {modulo === "1" && (
              <>
                {["6"].includes(idPerfil) && (
                  <li className="nav-item rounded-3 ps-2 linkNavBar">
                    <Icono iconName="pantalla" />
                    <Link to="/" className="nav-link active py-3 w-100">
                      Monitor
                    </Link>
                  </li>
                )}
                {["4"].includes(idPerfil) && (
                  <li className="nav-item rounded-3 ps-2 linkNavBar">
                    <Icono iconName="consulta" />
                    <Link to="/consulta-rut" className="nav-link active py-3 w-100">
                      Iniciar contratación
                    </Link>
                  </li>
                )}
                {!["6", "7"].includes(idPerfil) && (
                  <>
                    <li className="nav-item rounded-3 ps-2 linkNavBar">
                      <Icono iconName="prog" />
                      <Link to="/" className="nav-link active py-3 w-100">
                        Solicitudes en progreso
                      </Link>
                    </li>

                    <li className="nav-item rounded-3 ps-2 linkNavBar">
                      <Icono iconName="reing" />
                      <Link to="/listSolicitudReingreso" className="nav-link active py-3 w-100">
                        Solicitudes de reingreso
                      </Link>
                    </li>
                  </>
                )}
                {(["7"].includes(idPerfil) || ["1"].includes(localStorage.getItem("puedeverfirma"))) && (
                  //a esta seccion solo pueden ver perfil 7 O si tiene el token de tiene documentos o... es usuario monitor
                  <li className="nav-item rounded-3 ps-2 linkNavBar">
                    <Icono iconName="firma" />
                    <Link to={returnTo()} className="nav-link active py-3 w-100">
                      Gestión de firma de documentos
                    </Link>
                  </li>
                )}
                {["3"].includes(idPerfil) && (
                  <>
                    <li className="nav-item rounded-3 ps-2 linkNavBar">
                      <Icono iconName="enviosap" />
                      <Link to="/envio-sap" className="nav-link active py-3 w-100">
                        Por enviar a SAP
                      </Link>
                    </li>
                    <li className="nav-item rounded-3 ps-2 linkNavBar">
                      <Icono iconName="resumen" />
                      <Link to="/resumen-solicitudes" className="nav-link active py-3 w-100">
                        Resúmen de solicitudes
                      </Link>
                    </li>
                    {/* Log de temporis */}
                    <li className="nav-item rounded-3 ps-2 linkNavBar">
                      <Icono iconName="temporislog" />
                      <Link to="/log-temporis" className="nav-link active py-3 w-100">
                        {" "}
                        Log de temporis
                      </Link>
                    </li>
                    {/* Fin log de temporis */}
                  </>
                )}
              </>
            )}
            {modulo === "2" && (
              <>
                {!["4"].includes(localStorage.getItem("id_perfil")) && (
                  <li className="nav-item rounded-3 ps-2 linkNavBar">
                    <Icono iconName="prog" />
                    <Link to="/" className="nav-link active py-3 w-100">
                      Solicitudes en curso
                    </Link>
                  </li>
                )}
                {["4"].includes(localStorage.getItem("id_perfil")) && (
                  <>
                    <li className="nav-item rounded-3 ps-2 linkNavBar">
                      <Icono iconName="consulta" />
                      <Link to="/" className="nav-link active py-3 w-100">
                        Iniciar solicitud
                      </Link>
                    </li>
                  </>
                )}
                <li className="nav-item rounded-3 ps-2 linkNavBar">
                  <FontAwesomeIcon icon={faUsers} className="me-3" size="lg" />
                  <Link to="/solicitudes-traspaso" className="nav-link active py-3 w-100">
                    Solicitudes de traspaso
                  </Link>
                </li>
                {["3"].includes(localStorage.getItem("id_perfil")) && (
                  <>
                    <li className="nav-item rounded-3 ps-2 linkNavBar">
                      <Icono iconName="enviosap" />
                      <Link to="/envio-a-sap" className="nav-link active py-3 w-100">
                        Por enviar a SAP
                      </Link>
                    </li>
                    <li className="nav-item rounded-3 ps-2 linkNavBar">
                      <FontAwesomeIcon icon={faUserClock} className="me-3" size="lg" />
                      <Link to="/ajustes-de-dias" className="nav-link active py-3 w-100">
                        Ajustes de días
                      </Link>
                    </li>
                  </>
                )}
                <li className="nav-item rounded-3 ps-2 linkNavBar">
                  <Icono iconName="resumen" />
                  <Link to="/historial-solicitudes" className="nav-link active py-3 w-100">
                    Historial de solicitudes
                  </Link>
                </li>
              </>
            )}
            {modulo === "3" && (
              <li className="nav-item rounded-3 ps-2 linkNavBar">
                <FontAwesomeIcon icon={faUserAltSlash} className="me-3" size="lg" />
                <Link to="/desvinculacion-colaborador" className="nav-link active py-3 w-100">
                  Desvinculación colaborador
                </Link>
              </li>
            )}
          </ul>
        </div>

        <div className="px-3 pb-3">
          <p className="h6 mb-1 d-flex justify-content-end linkNavBar">Versión: {version}</p>

          <ul id="itemBar2" className="navbar-nav mb-2 mb-lg-0 d-flex justify-content-end flex-row bgArcopime">
            <li className="d-flex flex-column justify-content-center px-2" style={{ whiteSpace: "nowrap", fontSize: "14px", overflowX: "hidden" }}>
              <label className="text-white text-end"> {returnMayus(localStorage.getItem("usuarioNombre"))} </label>
              <hr className="lineaPerfil" />
              <label className="text-white fw-bold text-end"> {PUESTOS[localStorage.getItem("id_perfil") || "SIN DEFINIR"].toUpperCase()} </label>
            </li>

            <li className="nav-item">
              <div className="dropdown text-end">
                <div className="p-2 d-block link-dark text-decoration-none dropdown-toggle btnCerrarSesion rounded-3" id="dropdownUser1" data-bs-toggle="dropdown">
                  <img src={`https://${localStorage.getItem("foto_perfil")}`} alt="mdo" width="40" height="40" className="rounded-circle" />

                  {notificaciones.length > 0 && (
                    <span
                      className="badge bg-warning text-dark p-1 rounded-circle d-flex justify-content-center"
                      style={{
                        position: "absolute",
                        fontSize: "11px",
                        top: "30px",
                        right: "62px",
                        height: "20px",
                        width: "20px",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      <Icono iconName="notif" />
                    </span>
                  )}
                </div>
                <ul className="dropdown-menu dropdown-menu-end text-small" aria-labelledby="dropdownUser1">
                  {notificaciones.length > 0 && (
                    <li key={0} className="dropdown-item fw-bold d-flex justify-content-between align-items-center px-2" style={{ cursor: "pointer" }}>
                      Notificaciones
                      <span
                        className="badge rounded-pill bg-warning text-dark d-flex justify-content-center align-items-center"
                        style={{
                          height: "20px",
                          width: "20px",
                          paddingBottom: "6px",
                        }}
                      >
                        {notificaciones.length}
                      </span>
                    </li>
                  )}
                  <li className="dropdown-item-li" key={1}>
                    <a
                      className="dropdown-item px-2 d-flex justify-content-between align-items-center"
                      onClick={() => {
                        document.querySelector("#sideBarBtn").click();
                        ejecutar();
                      }}
                    >
                      Volver al menú <FontAwesomeIcon icon={faArrowsRotate} />
                    </a>
                  </li>
                  <li className="dropdown-item-li" key={2}>
                    <a
                      className="dropdown-item px-2 d-flex justify-content-between align-items-center"
                      onClick={() => {
                        modalEjecutar(cerrarSession, "Se cerrará la sesión, ¿Desea continuar?", null);
                      }}
                    >
                      Cerrar sesión <FontAwesomeIcon style={{ fontWeight: "700" }} icon={faArrowRightFromBracket} />
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
